import { c as _c } from "react/compiler-runtime";
import React from "react";
interface WaveWinnersPodiumPlaceholderProps {
  readonly height: string;
  readonly position: "first" | "second" | "third";
}
export const WaveWinnersPodiumPlaceholder: React.FC<WaveWinnersPodiumPlaceholderProps> = t0 => {
  const $ = _c(7);
  const {
    height,
    position
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      first: "tw-border-yellow-900/20",
      second: "tw-border-iron-700/20",
      third: "tw-border-amber-900/20"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const positionColors = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="tw-absolute tw-left-1/2 -tw-translate-x-1/2 -tw-top-6 tw-z-10"><div className="tw-w-12 tw-h-12 tw-rounded-xl tw-bg-iron-900/40 tw-border tw-border-iron-800/20" /></div>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = `tw-flex tw-flex-col tw-items-center tw-justify-center tw-w-full ${height} tw-bg-iron-950/40 tw-rounded-xl tw-border ${positionColors[position]} tw-backdrop-blur-sm tw-pt-8`;
  let t4;
  let t5;
  let t6;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="tw-w-24 tw-h-4 tw-mb-2 tw-rounded-lg tw-bg-iron-900/40" />;
    t5 = <div className="tw-w-20 tw-h-4 tw-mb-2 tw-rounded-lg tw-bg-iron-900/40" />;
    t6 = <div className="tw-w-16 tw-h-4 tw-rounded-lg tw-bg-iron-900/40" />;
    $[2] = t4;
    $[3] = t5;
    $[4] = t6;
  } else {
    t4 = $[2];
    t5 = $[3];
    t6 = $[4];
  }
  let t7;
  if ($[5] !== t3) {
    t7 = <div className="tw-relative">{t2}<div className={t3}>{t4}{t5}{t6}</div></div>;
    $[5] = t3;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  return t7;
};